import React from 'react';
import './ExecutiveSummaryTable.scss';
import { NoResult } from '@src/components/shared/no-result/no-result';
import { TryAgainWidgetMessage } from '@src/components/shared/try-again-message/try-again-widget-message';

export interface ExecutiveSummaryTableColumn {
  key: string;
  label: string;
  className?: string;
}

export interface ExecutiveSummaryTableProps<T> {
  columns: ExecutiveSummaryTableColumn[];
  data: T[];
  renderRow: (row: T, idx: number) => React.ReactNode;
  headerContent?: React.ReactNode;
  className?: string;
  noResult?: string;
  hasError?: boolean;
}

export const ExecutiveSummaryTable = <T,>({
  columns,
  data,
  renderRow,
  headerContent,
  noResult,
  hasError,
  className = '',
}: ExecutiveSummaryTableProps<T>) => (
  <div className={`executive-summary-table ${className}`}>
    {headerContent}
    <div className="es-table">
      <div className="es-table-header">
        {columns.map(col => (
          <div key={col.key} className={`es-th es-th-${col.key}`}>{col.label}</div>
        ))}
      </div>
      <div className="es-table-body">
        {data.map((row, idx) => renderRow(row, idx))}
        {data.length === 0 && noResult && !hasError && <NoResult title={noResult} hideSubTitle={true} />}
        {data.length === 0 && hasError && <TryAgainWidgetMessage />}
      </div>
    </div>
  </div>
);
